import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import SolicitudTarifas from "./pages/solicitudTarifas/solicitudTarifas";
import TarifasPendientes from "./pages/tarifasPendientes/tarifasPendientes";
import SectionHeader from "../../../components/sectionHeader/sectionHeader";
import Tabs from "../../../components/tabs/tabs";
import ComparativaTarifas from "./pages/comparativaTarifas/comparativaTarifas";
import HistoricoTarifas from "./pages/historicoTarifas.jsx/historicoTarifas";
import Resumen from "./pages/resumen/resumen";
import Precio from "./pages/precio/precio";
import ValidacionGOI from "./pages/validacionGOI/validacionGOI";
import UpdatePreciosV2 from "./pages/updatePreciosV2/updatePreciosV2";
import PreciosProvisionales from "./pages/preciosProvisionales/preciosProvisionales";

export default function GestionTarifas({ user }) {
    const isV2 = window.config?.isV2;
    const location = useLocation();
    const [activeTab, setActiveTab] = useState("solicitudTarifas");

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const tabFromUrl = urlParams.get('activeTab');
        if (tabFromUrl) {
            setActiveTab(tabFromUrl);
        }
    }, [location.search]);

    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
    };

    const tabs = [
                    { id: "solicitudTarifas", label: "Solicitar tarifas" },
                    { id: "tarifasPendientes", label: "Mis pendientes" },
                    { id: "comparativaTarifas", label: "Comparativa tarifas" },
                    { id: "historicoTarifas", label: "Histórico tarifas" },
                    { id: "validacionGOI", label: "Validación GOI" },
                    { id: "resumen", label: "Resumen" },
                    { id: "preciosProvisionales", label: "Precios provisionales" },
                    {id: "precio", label: "Calculadora de precios" }
                ]

    isV2 && tabs.push({id: "precioV2", label: "Calculadora de precios_V2" }, {id: "modifyPondV2", label: "Actualizar precios V2" });

    return (
        <section className="dashboard-usuarios">
            <SectionHeader
                title="Panel de Administrador - Gestión de tarifas"
                subtitle="Aquí puedes solicitar precios a proveedores, gestionar las tarifas y ver comparativas de histórico de cambios de precios"
            />

            <Tabs
                tabs={tabs}
                activeTab={activeTab}
                onTabChange={handleTabChange}
            />

            <div className="dashboard-usuarios__content">
                {activeTab === "solicitudTarifas" && <SolicitudTarifas />}

                {activeTab === "tarifasPendientes" && (
                    <TarifasPendientes user={user} />
                )}

                {activeTab === "historicoTarifas" && (
                    <HistoricoTarifas user={user} />
                )}

                {activeTab === "validacionGOI" && (
                    <ValidacionGOI user={user} />
                )}

                {activeTab === "comparativaTarifas" && (
                    <ComparativaTarifas user={user} />
                )}

                {activeTab === "resumen" && <Resumen user={user} />}
                {activeTab === "preciosProvisionales" && <PreciosProvisionales />}
                {activeTab === "precio" && <Precio user={user} />}
                {(activeTab === "precioV2" && isV2) && <Precio user={user} isV2={true} />}
                {activeTab === "modifyPondV2" && isV2 && <UpdatePreciosV2 user={user} />}
            </div>
        </section>
    );
}
